module.exports = __webpack_public_path__ + "static/media/chrome-mobile-step-3.5b121ce9.png";